import { jsx as _jsx } from "react/jsx-runtime";
export const KanbanNullStateColumn = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "rounded-t-lg bg-gradient-to-b from-grey-1 to-grey-2"
    });
};
